import "../../../App.css";
const Unauthorized = () => {
  return (
    <div className="underMaintainance-container">
      <div className="maintenceInnerContainer">
        <h2 className="maintenceInnerHeader">Authorization!</h2>
        <div className="maintenceInnerBody">
          <p>You are not authorized to access this link.</p>
        </div>
      </div>
    </div>
  );
};
export default Unauthorized;
